Plastic.Request = function(options){
    return new Promise(function(resolve, reject){
        if (typeof options === "string") options = {url: options};
        var {
            callback = null,
            data = null,
            failure = null,
            headers = {},
            method = "GET",
            onprogress = function(progress){},
            onchange = function(state){},
            success = null,
            url,
        } = options;

        var hasData = data !== null;
        if (hasData && typeof data === "object" && !(data instanceof FormData)){
            if (method.toUpperCase() === "GET"){
                url += `?${Plastic.Request.objToQueryStr(data)}`;
            }
            // Likely JSON, so type.
            headers["Content-Type"] = "application/json";
            data = JSON.stringify(data);
        }

        var request = {
            progress: {
                loaded: 0,
                percent: 0,
                total: 0
            },
            response: null,
            state: null,
            status: null,
            success: true
        };
        var xhr = new XMLHttpRequest();
        xhr.onerror = function(){
            request.status = xhr.status;
            reject();
        };
        xhr.onload = function(){
            request.status = xhr.status;
            if (request.status >= 400) request.success = false;

            var headers = xhr.getAllResponseHeaders().toLowerCase();
            if (headers.indexOf("json") >= 0 && xhr.responseType === ""){
                request.response = JSON.parse(xhr.response);
            }
            else request.response = xhr.response;
            complete();
        };
        xhr.onprogress = function(progress){
            if (progress.lengthComputable){
                request.progress = {
                    loaded: progress.loaded,
                    percent: (progress.loaded / progress.total) * 100,
                    total: progress.total
                };
                onprogress(request.progress);
            }
        };
        xhr.onreadystatechange = function(){
            switch (xhr.readyState) {
                case 0: request.state = "UNSENT";              break;
                case 1: request.state = "OPENED";              break;
                case 2: request.state = "HEADERS_RECEIVED";    break;
                case 3: request.state = "LOADING";             break;
                case 4: request.state = "DONE";                break;
            }
            onchange(request.state, request);
        };
        xhr.open(method, url);
        for (let header in headers){
            if (headers.hasOwnProperty(header)){
                xhr.setRequestHeader(header, headers[header]);
            }
        }

        xhr.send(data);

        function complete(){
            if (callback !== null) callback(request.success, request.response);
            else if (request.success){
                if (success !== null) success(request.response);
                else resolve(request.response);
            }
            else {
                if (failure !== null) failure(request.response, request);
                else reject({status: request.status, response: request.response});
            }
        }
    });
};
// Parameterize Obj (for GET requests)
Plastic.Request.objToQueryStr = function(obj){
    return Object.keys(obj)
        .map(key => [key, obj[key]]
            .map(encodeURIComponent).join('=')).join('&');
};